import React from 'react'
import classnames from 'classnames'

import './radiobutton.sass'

const RadioButton = ({ toggled }) =>
  <div className={classnames('radiobutton', {toggled: toggled})}></div>

export default RadioButton
